<template>
<div>
    <!-- CSS Global Compulsory -->
    <link rel="stylesheet" href="../../static/assets/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="../../static/assets/css/style.css">

    <!-- CSS Header and Footer -->
    <link rel="stylesheet" href="../../static/assets/css/header.css">
    <link rel="stylesheet" href="../../static/assets/css/footer.css">

        <div class="container content">
        </div>
 <div class="footer-v1">
        <div class="copyright">
            <div class="container">
                <div class="col">
                        <p>
                             <li>
                                  <a href="../../static/privacy.html" style="color: rgb(38, 104, 233);">隐私协议</a>
                                </li>
                                <li>
                                  <a href="../../static/protocol.html" style="color: rgb(38, 104, 233);">用户服务协议</a>
                                </li>
                                <li>
                                  <a href="../../static/tort.html" style="color: rgb(38, 104, 233);">侵权投诉指引</a>
                                </li>
                        </p>
                        <p>
                          <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备 18014986号-1</a><br>2019 &copy; 武汉云上塔兮信息技术有限公司 版权所有
                        </p>
                </div>

            </div>
        </div><!--/copyright-->
    </div>

</div>


</template>

<script>
export default {
    name:'ContactUs'
}
</script>



// WEBPACK FOOTER //
// src/views/ContactUs.vue